'use client';

import { useEffect } from 'react';
import BellIcon from '@/assets/images/bell-icon.svg';
import googleMeetLogo from '@/assets/images/google-meet.svg';
import { DMImage } from '@/components/custom-image/custom-image';
import R2Image from '@/components/custom-image/r2Image';
import { DMHoverCard } from '@/components/hover-card';
import { DMLink } from '@/components/link';
import useNotificationStore from '@/lib/zustand/store/notificationStore';
import EventButton from '@/screens/notifications/components/EventButton';
import { format } from 'date-fns';

type PropNotifications = {
  myLearnings: any[];
};

const NotificationList = () => {
  const { notificationList, fetchNotification, loading, error } = useNotificationStore();

  useEffect(() => {
    fetchNotification();
  }, []);

  return (
    <div className='bg-slate-800 rounded-full p-2 cursor-pointer'>
      <DMHoverCard
        id='notification'
        triggerContent={
          <div className='relative'>
            <DMImage src={BellIcon} alt='Notification Icon' width={26} height={26} />
            {notificationList.top10?.length > 0 && (
              <>
                <span className='animate-ping absolute top-0 right-0 h-4 w-4 rounded-full bg-brand-primary' />
                <div className='absolute top-0 right-0 h-4 max-h-8 min-w-4 max-w-8 rounded-full bg-brand-primary flex items-center justify-center text-black'>
                  <p className='text-black text-[9px] p-1'>{notificationList.top10?.length}</p>
                </div>
              </>
            )}
          </div>
        }
        content={
          <div>
            <div className='max-w-md mx-auto overflow-auto max-h-[300px]'>
              <div className='space-y-2'>
                {notificationList.top10?.length > 0 ? (
                  notificationList.top10?.map((notification: any) => (
                    <div
                      key={notification.id}
                      className='flex items-center space-x-3 w-full hover:bg-slate-800 hover:rounded-md p-1'
                    >
                      <div className='flex items-center space-x-4 flex-1'>
                        {notification?.oneOnOne ? (
                          <div className='rounded-full object-cover h-12'>
                            <DMImage
                              src={googleMeetLogo}
                              className='rounded-full object-cover w-full h-full'
                              height={50}
                              width={50}
                              alt='Google meet logo'
                            />
                          </div>
                        ) : (
                          <div className=' rounded-full object-cover h-14 w-14'>
                            <R2Image
                              height={400}
                              width={400}
                              className='rounded-full object-cover w-ful h-full'
                              fileName={notification?.orders?.course?.thumbnailImage as string}
                            />
                          </div>
                        )}
                        <div className='w-2/3 space-y-1'>
                          <p className='text-[10px] text-gray-500 leading-none mb-1'>
                            {format(new Date(notification?.createdAt), 'MMM d, yyyy h:mm a')}
                          </p>
                          <p className='font-semibold text-xs'>{notification?.title}</p>
                          <p className='text-[10px] p-0 leading-[16px] !mb-1 line-clamp-2'>
                            {notification?.message}
                            {notification?.oneOnOne?.link && notification?.type == 'success' && (
                              <strong className=''>
                                {format(
                                  new Date(notification?.oneOnOne.date),
                                  'MMM d, yyyy h:mm a'
                                )}
                              </strong>
                            )}
                          </p>

                          {notification?.oneOnOne?.link && notification?.type == 'success' && (
                            <div className='w-20 h-8'>
                              <EventButton
                                datetime={notification?.oneOnOne.date}
                                link={notification?.oneOnOne?.link}
                              />
                            </div>
                          )}

                          {notification?.orders && (
                            <p className='text-[10px] text-gray-500 !mt-0'>
                              Purchased on{' '}
                              {format(new Date(notification?.createdAt), 'MMM d, yyyy')}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <p className='text-xs text-center'>You don't have any notification</p>
                  </>
                )}
              </div>
            </div>
            {notificationList?.totalCount > 0 && (
              <div className='text-center mt-2'>
                <DMLink href='/notifications' className='text-sm'>
                  View All
                </DMLink>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

export default NotificationList;

export const NotificationCount = () => {
  const { notificationList } = useNotificationStore();
  return (
    <div className='absolute top-0 right-0 h-4 max-h-8 min-w-4 max-w-8 rounded-full bg-brand-primary flex items-center justify-center text-black'>
      <p className='text-black text-[9px] p-1'>{notificationList.top10?.length}</p>
    </div>
  );
};
